export default __webpack_public_path__ + "static/media/pricetracq-logo.c15435ba.svg";